import { render } from "./AdDocumentHeaderLinks.vue?vue&type=template&id=5e5d967c&ts=true"
import script from "./AdDocumentHeaderLinks.vue?vue&type=script&lang=ts"
export * from "./AdDocumentHeaderLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__